'use strict';

function SwitchAccounts($timeout, $location, $rootScope) {
	let searchObject = $location.search();

	if (searchObject.missingSite) {
		let missingSite = searchObject.missingSite;
		$location.search('missingSite', null);

		$timeout(function () {
			$rootScope.$broadcast('pmtInsufficientPermissionsError', {
				message: { route: missingSite }
			});
		}, 1000);
	}
}

SwitchAccounts.$inject = ['$timeout', '$location', '$rootScope'];

angular.module('PinMeTo.switchAccount').component('pmtSwitchAccountsCtrl', {
	templateUrl: 'pmtShared/switchAccount/switchAccountsView.html',
	controller: SwitchAccounts
});
